import React, { Component } from 'react';
import { connect } from 'react-redux';

import {getCurrentUser} from '../../actions/session';

class BlackList extends Component {

  onRemoveClick(e, user) {
    e.preventDefault();
    this.props.onModalClick(user);
  }

  render() {
    const blackList = this.props.session.currentUser.blacklist_users;

    return (
        <div className="right-content native-scroll right-content-bottom right-content-width">
          <div className="screen-outer-block-wrap native-scroll menu-content">
            <div className="menu-content-blacklist menu-content-item tab-parent screen-center-block">
              <div className={"rounded-white-block" + (blackList.length ? "" : " empty")}>
              <div className='blacklist-block'>
                <h1 className='blacklist-title'>Черный список</h1>
                {blackList.length ? blackList.map(user => {
                  return (
                    <div key={user.id} className="blacklist-user__item">
                      <div className="name">{user.first_name + ' ' + user.last_name}</div>
                      <a href='' onClick={(e) => this.onRemoveClick(e,user)}>Удалить из черного списка</a>
                    </div>
                  )
                }
                )
                :
                <span className='blacklist-empty'>Черный список пуст</span>}
              </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default connect(
  state => ({
    session: state.session
  })
)(BlackList);


// WEBPACK FOOTER //
// ./src/components/Account/BlackList.js